import { FC, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useLocation } from 'react-router-dom';
import isEmpty from 'lodash/isEmpty';

import { isAuthenticatedUserSelector } from 'store/selectors/userSelectors';
import { getSettingsByKeyAction, updateSettingsByKeyAction } from 'store/actions/settingsActions';
import { getUserSettingsAction } from 'store/actions/userActions';
import { ESettingsKey } from 'store/reducers/settingsReducer/settingsTypes';
import { useTypedSelector } from 'hooks/useTypedSelector';
import { STORAGE_KEYS } from 'utils/constants/constants';
import { ERoutePaths } from 'types/routes/enums';

const withNecessaryData = (Component: FC) => () => {
  const dispatch = useDispatch();
  const { pathname } = useLocation();
  const isAuthenticatedUser = useTypedSelector(isAuthenticatedUserSelector);
  const fromShopify = JSON.parse(localStorage.getItem(STORAGE_KEYS.fromShopifySocial) || '{}');

  useEffect(() => {
    if (isAuthenticatedUser) {
      dispatch(getSettingsByKeyAction(ESettingsKey.AccountSettings));
      pathname !== ERoutePaths.Home && dispatch(getUserSettingsAction());
      if (!isEmpty(fromShopify)) {
        const { code: shopifyCode, shop: url } = fromShopify;

        dispatch(updateSettingsByKeyAction({ shopifyCode, url }, ESettingsKey.StoreSettings, true));
        localStorage.removeItem(STORAGE_KEYS.fromShopifySocial);
      }
    }
  }, [isAuthenticatedUser]);

  return <Component />;
};

export default withNecessaryData;
